import {
	isContentMax,
	isMobile,
	isTablet
} from "components/utility/page-responsive/PageResponsive";
import {
	animatedParagraphObserverDisconnect,
	observeAnimatedParagraphs
} from "./animatedParagraphObserver";
import { showSplitParagraphContent } from "./distance-based-animations/splitContentBlock";
import { observeDistanceElements } from "./distance-based-animations/distanceElementsObserver";
import {
	observeAnimatedSectionHeaders,
	animatedSectionHeadersDisconnect
} from "./distance-based-animations/animatedSectionHeader";
import {
	observeMicroCap,
	microCapObserverDisconnect
} from "utils/ddiff-animations/distance-based-animations/microCapObserver";
import { showMicroCapContent } from "./distance-based-animations/animateMicroCap";
import { showDonutsContent } from "./distance-based-animations/animateDonuts";
import {
	showInfographicMobileToLarge,
	showStaticInfographic
} from "./distance-based-animations/animatedInfoHeadline";

const triggerDDiffAnimations = () => {
	observeDistanceElements();
	observeAnimatedSectionHeaders();
	showStaticInfographic();

	if (!isMobile() && !isTablet()) {
		// => 1024
		observeAnimatedParagraphs();
	}

	if (!isContentMax()) {
		// <= 1440
		showSplitParagraphContent();
	}

	if (isMobile()) {
		showMicroCapContent();
		showDonutsContent();
		showInfographicMobileToLarge();
	} else {
		observeMicroCap();
	}

	// Limit observations based on breakpoint
	window.addEventListener("resize", () => {
		showStaticInfographic();
		if (isMobile() || isTablet()) {
			animatedParagraphObserverDisconnect();
		} else {
			observeAnimatedParagraphs();
		}

		if (isMobile()) {
			showMicroCapContent();
			animatedSectionHeadersDisconnect();
			microCapObserverDisconnect();
			showDonutsContent();
			showInfographicMobileToLarge();
		} else {
			observeAnimatedSectionHeaders();
		}

		if (!isContentMax()) {
			showSplitParagraphContent();
		}
	});
};

export default triggerDDiffAnimations;
